export const baseUrl = {
    // url: 'https://apidibex.selopian.us/api/v1',
    url: 'https://api.designinbangladeshweek.com/api/v1',
    // img: 'https://apidibex.selopian.us',
    img: 'https://api.designinbangladeshweek.com',
    // url: process.env.REACT_APP_BASE_URL,
    // img: process.env.REACT_APP_IMAGE_URL,
    map_api_key: '',
    mapId: '',
    vapidKey: '',
    tinymce_api_key: process.env.REACT_APP_TINYEDITOR_TOKEN,
}

export const firebaseConfig = {
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
    storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
    measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID
};